
import { Auth0Provider } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import AuthErrorHandler from "./AuthErrorHandler";

export default function Auth0ProviderWithNavigate({ children }) {
  const navigate = useNavigate();
  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;

  const onRedirectCallback = (appState) => {
    const target = appState?.returnTo || "/profile";
    navigate(target, { replace: true });
  };

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: "https://someet-api",
        scope: "openid profile email",
      }}
      onRedirectCallback={onRedirectCallback}
      cacheLocation="memory"
      useRefreshTokens={true}
    >
      <AuthErrorHandler>
        {children}
      </AuthErrorHandler>
    </Auth0Provider>
  );
}
